import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../../themes'
const Style = styled.div`
  .svg_tooltip_text,
  .text-svg {
    stroke-width: 0px;
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.XXS};
    fill: ${COLOR.BLACK_1};
  }
  .svg_tooltip_rect {
    stroke-width: 1;
    stroke: ${COLOR.GOLD_1};
  }
  #linkOverlay{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
  }
  .available polygon,
  .busy polygon {
    transition: fill 0.2s ease, stroke 0.2s ease;
  }
  .available polygon {
    fill: transparent;
    stroke: none;
  }
  .busy polygon {
    fill: var(--busy-fill);
    stroke: var(--busy-stroke);
    stroke-width: 2px;
    fill-opacity: 1;
  }
  .available:hover polygon {
    fill: rgba(0, 0, 0, 0.04);
  }
  .busy:hover polygon {
    fill: var(--busy-fill-hover);
  }
  .room-box-inner {
    border: 4px solid transparent;
  }
  .room-group:hover .room-box-inner {
    border: 4px solid ${COLOR.BLACK_6};
  }
  .room-label {
    overflow: visible;
  }
  .static-tooltip {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .room-group:hover .static-tooltip {
    opacity: 1;
  }
  .pointer {
    cursor: pointer;
  }
  .svg_tooltip_p {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    transform: translate(-50%, 0);
    padding: 9px 18px;
    box-sizing: border-box;
    width: max-content;
    margin: 0;

    background-color: #000000;
    font-family: NunitoSansRegular, 'Nunito Sans', sans-serif;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 16px;
    border-radius: 8px;
    white-space: nowrap;
  }

  .svg_tooltip_p::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 12px;
    height: 12px;
    background-color: #000000;
    border-radius: 2px;
    z-index: -1;
  }
`

export default Style

